import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

/**
 * Placeres én gang omkring hele appen. `delayDuration` er sat lavt nok til at
 * føles responsivt, men højt nok til at tooltips ikke blinker frem når musen
 * bevæger sig hen over en værktøjslinje.
 */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipPrimitive.Provider delayDuration={250} skipDelayDuration={300}>
      {children}
    </TooltipPrimitive.Provider>
  )
}

export interface TooltipProps {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
}

/**
 * Tooltip er altid supplerende information. Kritisk indhold må aldrig kun
 * findes her, da tooltips ikke er tilgængelige på touch-enheder.
 */
export function Tooltip({ content, children, side = 'top', align = 'center' }: TooltipProps) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          align={align}
          sideOffset={6}
          className={cn(
            'z-50 max-w-xs rounded-lg border border-line-strong bg-app-800 px-2.5 py-1.5',
            'text-xs text-text-primary shadow-[var(--shadow-raised)]',
            'duration-[var(--duration-hover)] ease-[var(--ease-out-soft)]',
          )}
        >
          {content}
          <TooltipPrimitive.Arrow className="fill-app-800" width={10} height={5} />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
